import { useEffect, useRef } from "react";

import isEqual from "lodash/isEqual";

export const useChangeEffect = <T>(value: T, callback: (value: T) => void) => {
  const previousData = useRef<T>(value);

  useEffect(() => {
    if (!isEqual(value, previousData.current)) {
      previousData.current = value;
      callback(value);
    }
  }, [previousData, value, callback]);
};
